import { render, staticRenderFns } from "./AIAgentList.vue?vue&type=template&id=4f9af987"
import script from "./AIAgentList.vue?vue&type=script&lang=js"
export * from "./AIAgentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports